import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import ModalAlert from '../../components/ModalAlert';
import PostByAgg from '../../utils/axios';
import LottieLoading from '../../components/child/LottieLoading';

const ChannelForm = ({ open, mode, channel, handleClose , refreshData}) => {
    const [formData, setFormData] = useState({
        channel_code: '',
        channel_name: '',
        description: '',
        is_active: '',
    });
    const [modal, setModal] = useState(<div></div>);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        if (channel) {
            setFormData(channel); // Update form data when channel is selected
        }
    }, [channel]);

    const handleDelete = () => {
        // Logic for deleting the channel
        console.log('Deleting channel:', channel);
        handleClose(); // Close the modal after delete
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
        console.log("ini submit ")
        let url = 'song/v1/channel/create';  // Default URL for create action
        let body = {
            "channel_name": formData.channel_name,
            "is_active": JSON.parse(formData.is_active),
            "created_by": "Admin"
        };

        if (mode === 'update') {
            url = 'song/v1/channel/update'; // Change URL for update action
            body = {
                "channel_code": channel.channel_code, 
                "channel_name": formData.channel_name,
                "description": formData.description || "",
                "is_active": JSON.parse(formData.is_active),
                "updated_by": "Admin Update"
            };
        }
       PostByAgg({
           url,
           body: body,
           onResponse: onResponseCreate,
           onError: onResponseErrorCreate
       });
       
       function onResponseCreate(response) {
        console.log("Response from create:", response.data)
        setIsLoading(false);
        if(response.data.code === "2002000"){
            setModal(
                <ModalAlert
                    show={true}
                    type={"success"}
                    text={response.data.message.id}
                    action = {() => {
                        setModal(<div></div>);
                        refreshData();
                        handleClose();
                    }}
                    />
            )
        }
       }

       function onResponseErrorCreate(error) {
        console.log("error from create:", error.response.data)
        setIsLoading(false);
        if(error.response.data.code === "4003400"){
            setModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    text={error.response.data.message.id}
                    action = {() => {
                        handleClose();
                    }}
                    />
            )
        }
       }
    };

    return (
        <div
            className={`modal fade ${open ? "show" : ""}`}
            tabIndex="-1"
            style={{ display: open ? "block" : "none" }}
            aria-hidden={!open}
        >
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header justify-content-between">
                        <h5 className="modal-title">{mode === 'create' ? 'Create Channel' : mode === 'view' ? 'View Channel' : mode === 'update' ? 'Update Status Channel' : 'Delete Channel'}</h5>
                        <button type="button" className="close" onClick={handleClose}>
                            <Icon icon="mdi:close-circle" width={24} height={24} />
                        </button>
                    </div>
                    <div className="modal-body">
                        {mode === 'delete' ? (
                            <div>
                                <p>Are you sure you want to delete the user: <strong>{formData.name}</strong>?</p>
                                <div className="d-flex justify-content-end gap-2 mt-3">
                                    <button type="button" className="btn btn-danger" onClick={handleDelete}>
                                        Delete
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                   {[
                                        { label: 'Channel Name', name: 'channel_name' },
                                    ].map(({ label, name }) => (
                                        <div className='col-md-6 mb-3' key={name}>
                                            <label className="col-form-label" htmlFor={name}>
                                                {label}:
                                            </label>
                                            <input
                                                required
                                                type="text"
                                                className="form-control"
                                                id={name}
                                                name={name}
                                                placeholder='Channel Name'
                                                value={formData[name] || ''}
                                                onChange={(e) => setFormData({ ...formData, [name]: e.target.value })}
                                                readOnly={mode === 'view'} // Make fields read-only in 'view' mode
                                                disabled={mode === 'view'} // Disable input in 'view' mode
                                            />
                                        </div>
                                    ))}

                                        <div className="col-md-6 mb-3">
                                            <label className="col-form-label" htmlFor="status">
                                                Status:
                                            </label>
                                           <select
                                                required
                                                className="form-select"
                                                id="status"
                                                name="is_active"
                                                value={formData.is_active !== undefined ? formData.is_active : ''}
                                                onChange={(e) => setFormData({ ...formData, is_active: e.target.value })}
                                                disabled={mode === 'view'} // Disable in 'view' mode
                                            >
                                                <option value="">Select Status</option>
                                                <option value={true}>Active</option>
                                                <option value={false}>Inactive</option>
                                            </select>
                                        </div>

                                    {mode !== 'create' && (
                                        <>
                                            <div className="col-md-6 mb-3">
                                                <label className="col-form-label" htmlFor="created_at">
                                                    Created At:
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="created_at"
                                                    name="created_at"
                                                    value={formData.created_at || ''}
                                                    disabled={mode !== 'create'} // Disable in 'view' mode
                                                />
                                            </div>
                                            <div className="col-md-6 mb-3">
                                                <label className="col-form-label" htmlFor="created_by">
                                                    Created By:
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="created_by"
                                                    name="created_by"
                                                    value={formData.created_by || ''}
                                                    disabled={mode !== 'create'} // Disable in 'view' mode
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                        {mode === 'create' && (
                                            <button type="submit" className="btn btn-primary">
                                                Create
                                            </button>
                                        )}
                                        {mode === 'update' && (
                                            <button type="submit" className="btn btn-primary">
                                                Update
                                            </button>
                                        )}
                                        {mode === 'view' && (
                                            <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                                Close
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>
                        )}
                    </div>
                    {isLoading && <LottieLoading text='Proccessing...' />}
                    {modal}
                </div>
            </div>
        </div>
    );
};

export default ChannelForm;
